import { Permission } from '@/app/types';

export type CapturePermission = 'microphone' | 'camera';

export const CAPTURE_PERMISSION: Record<Permission, CapturePermission> = {
  audio: 'microphone',
  video: 'camera',
};

const UNSUPPORTED = 'unsupported';

/**
 * What the browser itself says about a capture permission, for diagnostics.
 * Not every browser answers for 'microphone' or 'camera' — Firefox rejects the
 * names outright — so no verdict is a normal answer here rather than a failure.
 */
export const readCapturePermissionState = async(name: CapturePermission) => {
  try {
    const status = await navigator.permissions?.query({ name } as unknown as PermissionDescriptor);

    return status?.state ?? UNSUPPORTED;
  } catch {
    return UNSUPPORTED;
  }
};
